import * as React from 'react'
import { Box } from "@mui/material"
import {TooltipSeeker} from "@ui-seeker/core"
import {formatNumber, isEmpty} from "@ui-seeker/utils"


export default function graphColumn(value, label) {
	return {
		name: value, label: label,
		options: {
			filter: false,
			customBodyRowRenderLite: (_, rowData) => <GraphBar dict={rowData[value]}/>
			}
		}
	}

const GraphBar = ({dict}) => {
	if (isEmpty(dict)) return <></>

	const total = Object.values(dict).reduce((acc, value) => acc + value, 0)

	return <Box sx={{display: 'flex', height: '15px', width: '100%', borderRadius: '10px', overflow: 'hidden'}}>
		{Object.keys(dict).map((key) => {
			const percentage = (dict[key] / total) * 100

			return <TooltipSeeker key={key} title={`${key}: ${formatNumber(percentage, {decimals: 0})}%`}>
					<Box sx={{width: `${percentage}%`, backgroundColor: getSegmentColor(key), height: '100%'}} />
				</TooltipSeeker>
		})}
	</Box>
}

const getSegmentColor = (key) => {
  const colorMap = {
	'Same as RRSP': '#26aaff',
	'Above RRSP': '#44e0a8',
	'Below RRSP': '#ff4953',
	'Meet': '#26aaff',
	'Beat': '#44e0a8',
	'Lose': '#ff4953',
  }
  return colorMap[key] || '#cccccc'
}

